import script from "./sidebar-menu-section.vue?vue&type=script&setup=true&lang=ts"
export * from "./sidebar-menu-section.vue?vue&type=script&setup=true&lang=ts"

import "./sidebar-menu-section.vue?vue&type=style&index=0&id=c4af023c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4af023c"]])

export default __exports__